// client/src/utils/renderUtils.js
import React from 'react';
import ItemIcon from '../components/ItemIcon.jsx';
import itemList from '../data/itemMap.json';

const itemMap = Object.fromEntries(
    itemList.map(item => [String(item.id), item.name])
);

export function renderItemOrText(id, size = 24, idx = null) {
    const key = idx !== null ? `${id}-${idx}` : id;
    return (
        /^\d+$/.test(id) && itemMap[id] ? (
            <ItemIcon key={key} id={id} size={size} />
        ) : (
            <span key={`txt-${key}`} className="answer-text">{id}</span>
        )
    );
}
